module.exports = __webpack_public_path__ + "img/layout-1.a4629b63.jpg";